import AppUseInfoPopup from './app-use-info-popup.view';

export default AppUseInfoPopup;
